import React from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";

const MCQTest = ({ testName, numberOfQuestions, cutOff }) => {
  return (
    <div className="container mx-auto ">
      {isNaN(numberOfQuestions) || numberOfQuestions === 0 ? (
        // <div className="w-full md:mx-8  mt-5 flex flex-col items-start space-y-4">
        //   {/* Header Section */}
        //   <div className="flex items-center space-x-2">
        //     <AiOutlineIssuesClose className="text-red-500 text-3xl" />
        //     <span className="text-red-500 font-bold text-lg ">
        //       MCQ test not added
        //     </span>
        //   </div>

        //   {/* Warning Message Section */}
        //   {/* <div className="flex items-center space-x-2">
        //     <AiFillWarning className="text-yellow-500 text-2xl" />
        //     <span className="text-yellow-600 text-sm font-semibold">
        //       You skipped this section, add HR interview to make your interview
        //       process within time.
        //     </span>
        //   </div> */}

        //   {/* Divider */}
        // </div>
        <></>
      ) : (
        <div className=" md:mx-8 mx-4 mt-5 mb-3 ">
          <div className="flex justify-between items-center mb-4">
            <div className="flex items-center space-x-2">
              <AiOutlineCheckCircle className="text-green-500 text-3xl" />
              <span className="text-green-500 font-bold text-lg ">
                MCQ test
              </span>
            </div>
            {/* <button
                    onClick={onEdit}
                    className="text-primary text-sm flex flex-row hover:underline">
                    Edit details <RiEditLine className="mt-1 ml-1" />
                  </button> */}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 text-gray-800">
            <div className="flex items-center">
              <span className=" pl-2">
                Assessment Name: <span className="font-bold">{testName}</span>
              </span>
            </div>
            <div className="flex items-center">
              <span className=" pl-2">
                Number of questions:{" "}
                <span className="font-bold">{numberOfQuestions}</span>
              </span>
            </div>
            <div className="flex items-center">
              <span className=" pl-2">
                CutOff: <span className="font-bold">{cutOff !== undefined && cutOff !== null && cutOff !== "" && cutOff !== "undefined" ? cutOff+ "%" : "Not Mentioned"}</span>
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MCQTest;
